import { render } from "./SmsInbox.vue?vue&type=template&id=93dd9a28"
import script from "./SmsInbox.vue?vue&type=script&lang=js"
export * from "./SmsInbox.vue?vue&type=script&lang=js"

import "./SmsInbox.vue?vue&type=style&index=0&id=93dd9a28&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__